import React from "react";
import "./statCard.css";

const StatCard = ({ icon, head, body }) => {
  return (
    <div className="statCard">
      <img src={icon} className="icon" alt="icon" />
      <div className="text">
        <span className="head">{head}</span>
        <span className="body">{body}</span>
      </div>
    </div>
  );
};

export default StatCard;
